export const USER_MANAGEMENT = true
export const POSITION_MANAGEMENT = true
export const REPORTING_TOOLS = true
export const USER_MANAGEMENT_DETAIL = true
export const MERCHANT_MANAGEMENT = true
export const ACCOUNT_MANAGEMENT = true
export const ACQUISITION_REVIEW = true
export const VISIT_ASSIGNMENT = true
